// extracted by mini-css-extract-plugin
export default {"title":"MessageDialog_title__RNkuH","actions":"MessageDialog_actions__He7lt","action-button":"MessageDialog_action-button__r2R4T"};